import ShopByBrandMenu from './shop-by-brand-menu.component';

export default ShopByBrandMenu;
